import { useAbTestComponent, loadUsualComponent } from "@hook";
import { inject, observer } from "mobx-react";

import Default from "./Default";
import AB_3156 from "./AB_3156";

const abTests = {
    dev_3156__v2: loadUsualComponent(AB_3156),
};

const InheritGeo = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = mainStore.getMainStore("init");
        const Specified = useAbTestComponent({ init, abTests, defaultComponent: Default });

        return <Specified {...props} />;
    }),
);

export default InheritGeo;
